import { useState } from "react";
import { Play, ImageIcon } from "lucide-react";

export function VideoThumbnail({
  thumbnailUrl,
  hasVideo,
  status,
  onClick,
  className = "",
  fallbackText = "Thumbnail will be uploaded by admin",
  testId = "video-thumbnail",
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const playable = !!hasVideo && status === "tersedia";
  const showImage = !!thumbnailUrl && !imgFailed;
  return (
    <div
      className={`relative aspect-video w-full overflow-hidden rounded-xl border border-border bg-muted/40 group ${
        playable ? "cursor-pointer" : ""
      } ${className}`}
      onClick={playable ? onClick : undefined}
      data-testid={testId}
    >
      {showImage ? (
        <img
          src={thumbnailUrl}
          alt=""
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={() => setImgFailed(true)}
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center px-6">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-background/40 backdrop-blur-sm border border-border mb-3">
              <ImageIcon className="h-5 w-5 text-muted-foreground" strokeWidth={1.5} />
            </div>
            <p className="text-xs text-muted-foreground">{fallbackText}</p>
          </div>
        </div>
      )}

      {/* gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0 pointer-events-none" />

      {/* play button */}
      {playable && (
        <div className="absolute inset-0 flex items-center justify-center transition-opacity">
          <div className="h-14 w-14 rounded-full bg-white/15 backdrop-blur-md border border-white/30 flex items-center justify-center group-hover:scale-110 transition-transform">
            <Play className="h-6 w-6 text-white fill-white ml-0.5" />
          </div>
        </div>
      )}
    </div>
  );
}
